/** Uma linha da tabela: o rótulo do documento antigo e o valor já resolvido em texto. */
export interface LinhaDoDocumento {
  rotulo: string
  valor: string
}

interface Props {
  /** A faixa laranja no topo da tabela. */
  titulo: string
  linhas: LinhaDoDocumento[]
}

/**
 * A tabela de duas colunas do RDM: rótulo em salmão à esquerda, valor em cinza à direita.
 *
 * Aparece duas vezes no documento — na identificação da mudança e no bloco de teste — e as
 * duas com a mesma marcação.
 *
 * `<th scope="row">` no rótulo e `<th scope="col">` no título, em vez de `<td>` em negrito:
 * é o que faz um leitor de tela anunciar "Prioridade: Alta" em vez de ler treze valores
 * soltos depois de treze rótulos soltos. O documento é impresso, mas antes de ser impresso
 * ele é conferido na tela, e quem confere pode estar navegando por leitor de tela.
 *
 * @param props o título da faixa e as linhas
 * @returns a tabela de rótulos e valores
 */
export function TabelaDeRotulos({ titulo, linhas }: Props) {
  return (
    <table className="rdm-tabela">
      <thead>
        <tr>
          <th scope="col" colSpan={2}>
            {titulo}
          </th>
        </tr>
      </thead>
      <tbody className="rdm-rotulos">
        {linhas.map((linha) => (
          <tr key={linha.rotulo}>
            <th scope="row">{linha.rotulo}</th>
            <td>{linha.valor}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
